import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardLayout from '../../../../layoutcontainers/DashboardLayout';
import { Box, Card, CardContent, CardHeader, Stack } from '@mui/material';
import { BsFillPersonVcardFill } from 'react-icons/bs';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialButton from '../../../../components/MaterialButton';
import MaterialBox from '../../../../components/MaterialBox';
import Grid from "@mui/material/Grid2";

const SalesOrderView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data;
    const filterData = location?.state?.filterData;
  return (
    <DashboardLayout>
    <Card sx={{ minHeight: "90vh" }}>
      <CardContent>
        <Stack
          direction="row"
          spacing={1}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <BsFillPersonVcardFill style={{ fontSize: 20 }} />
          <MaterialTypography
            component="label"
            variant="body2"
            fontWeight="bold"
          >
            Sales Order Report View
          </MaterialTypography>
        </Stack>
        <div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
            }}
          >
            <Card
              sx={{
                maxWidth: 700,
                width: "100%",
                borderRadius: 3,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
              }}
            >
              <CardHeader
                title={
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Sales Order 
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                }
              />
              <CardContent>
                <Grid container>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Box mt={2}>
                      <MaterialTypography
                        variant="subtitle1"
                        fontWeight="bold"
                      >
                        Order Details
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Sales Order ID:</strong> {data?.orderSio  }
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Customer Name:</strong> { data?.customerName}
                      </MaterialTypography>
                     <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Order Date:</strong> { data?.orderDate}
                      </MaterialTypography>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Box mt={2}>
                      <MaterialTypography
                        variant="subtitle1"
                        fontWeight="bold"
                      >
                        Item Details
                      </MaterialTypography>
                      {
                        data?.products?.map((value,index)=><Box key={index}>
                           <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Item Name:</strong> {value?.productName}
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Quantity:</strong> { value.quantity}{" "}
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Price Code:</strong> {value.priceCode}{" "}
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Product Price:</strong> {value.price}{" "}
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Tax:</strong> {value.tax}{" "}
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Amount:</strong> {value.amount}{" "}
                      </MaterialTypography>
                          </Box>)
                      }
                     

                       <Box mt={2}>
                      <MaterialTypography
                        variant="subtitle1"
                        fontWeight="bold"
                      >
                        Amount  Details
                      </MaterialTypography>
                      {/* <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Terms & condition:</strong> {data?.teamsAndConditions || filterData?.teamsAndConditions}
                      </MaterialTypography> */}
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Discount:</strong> {data?.discount || filterData?.discount}
                      </MaterialTypography>
                      <MaterialTypography
                        fontSize="16px"
                        color="textSecondary"
                      >
                        <strong>Total Amount:</strong> {data?.totalAmount || filterData?.totalAmount}
                      </MaterialTypography>
                    </Box>
                    </Box>


                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                   
                  </Grid>
                </Grid>
              </CardContent>
              <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={() => navigate("/sales-order-report")}
                >
                  Back
                </MaterialButton>
              </MaterialBox>
            </Card>
          </Box>
        </div>
      </CardContent>
    </Card>
  </DashboardLayout>
  )
}

export default SalesOrderView
